import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useProfileQuery } from '@entities/manufacturer';
import { ROUTES } from '@shared/config/routes';

export function KycBanner() {
  const { t } = useTranslation();
  const { data: profile } = useProfileQuery();
  if (!profile || profile.kycStatus === 'VERIFIED') return null;

  const type: 'info' | 'warning' | 'error' =
    profile.kycStatus === 'REJECTED'
      ? 'error'
      : profile.kycStatus === 'PENDING'
        ? 'warning'
        : 'info';

  const message =
    profile.kycStatus === 'PENDING'
      ? t('kyc.banner.pending')
      : profile.kycStatus === 'REJECTED'
        ? t('kyc.banner.rejected', {
            reason: profile.kycReason ? `: ${profile.kycReason}` : '',
          })
        : t('kyc.banner.none');

  return (
    <Alert
      type={type}
      message={
        <Link to={`${ROUTES.profile}?tab=kyc`} style={{ color: 'inherit' }}>
          {message}
        </Link>
      }
      showIcon
      banner
      style={{ borderRadius: 6, fontSize: 12 }}
    />
  );
}
